import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { create } from '../store'

interface BalancesStore {
  selectedWallet: { address: string; name: string };
  setSelectedWallet: (wallet: string, name: string) => void;
}

export const useBalancesStore = create<BalancesStore>()(
  devtools(
    immer((set) => ({
      selectedWallet: null,
      setSelectedWallet: (wallet: string, name: string) => set(() => ({ selectedWallet: { address: wallet, name } }), false, 'setSelectedWallet'),
    })),
    {
      name: 'useBalancesStore',
    },
  ),
)
